import React, { useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import TemplatedMenuPage from './TemplatedMenuPage';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8081';

const generateSlug = (name) => {
  if (!name) return 'shop';
  return name
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '')
    .replace(/[\s_-]+/g, '-')
    .replace(/^-+|-+$/g, '');
};

const ShopTemplatedWrapper = () => {
  const { shopSlug, shopCode } = useParams();
  const history = useHistory();
  const actualShopCode = shopCode ? shopCode : shopSlug;
  const [loading, setLoading] = useState(true);
  const [shopId, setShopId] = useState(null);

  useEffect(() => {
    let isMounted = true;
    const load = async () => {
      try {
        setLoading(true);
        const resp = await axios.get(`${API_BASE_URL}/api/vendor/shops/code/${encodeURIComponent(actualShopCode)}`);
        if (resp?.data?.success && resp.data.data) {
          const shop = resp.data.data;
          const expectedSlug = generateSlug(shop.shopName);
          
          if (shopSlug !== expectedSlug) {
            history.replace(`/${expectedSlug}/${actualShopCode}`);
            return;
          }

          if (isMounted) setShopId(shop.shopId || shop.id);
        } else {
          toast.error('Shop not found');
        }
      } catch (error) {
        console.error('Failed to load shop by code', error);
        toast.error('Failed to load shop');
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    load();
    return () => { isMounted = false; };
  }, [actualShopCode, shopSlug, history]);

  if (loading) return <div className="min-h-screen flex items-center justify-center"><div className="text-lg text-gray-600">Loading shop...</div></div>;
  if (!shopId) return <div className="min-h-screen flex items-center justify-center"><div className="text-lg text-red-600">Shop not available</div></div>;

  return (
    <TemplatedMenuPage shopMode={true} shopId={shopId} />
  );
};

export default ShopTemplatedWrapper;
